<app-modal [isOpen]="isOpen" (close)="onClose()" className="max-w-4xl mx-4 sm:mx-6">
@if (segment) {
<div class="p-6 sm:p-8">

  <!-- Error banner -->
  @if (error) {
  <div class="mb-6 p-4 bg-error-50 border border-error-200 rounded-xl dark:bg-error-500/10 dark:border-error-500/20">
    <div class="flex items-center gap-3">
      <svg class="w-5 h-5 text-error-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
      </svg>
      <p class="text-error-600 dark:text-error-400 font-medium">{{ error }}</p>
    </div>
  </div>
  }

  <!-- Header -->
  <div class="flex items-start gap-5 mb-8">
    <!-- Icon circle -->
    <div class="flex-shrink-0">
      <div class="flex h-16 w-16 items-center justify-center rounded-full"
        [ngClass]="segment.type === 'DYNAMIC' ? 'bg-brand-100 dark:bg-brand-900/30' : 'bg-gray-100 dark:bg-gray-800'">
        @if (segment.type === 'DYNAMIC') {
        <svg class="w-8 h-8 text-brand-600 dark:text-brand-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
        </svg>
        } @else {
        <svg class="w-8 h-8 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
        </svg>
        }
      </div>
    </div>

    <!-- Name + badges -->
    <div class="flex-1 min-w-0">
      <h2 class="text-2xl font-bold text-gray-900 dark:text-white mb-2">{{ segment.name }}</h2>
      <div class="flex items-center gap-2 flex-wrap">
        <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
          [ngClass]="segment.type === 'DYNAMIC'
            ? 'bg-brand-50 text-brand-700 dark:bg-brand-500/10 dark:text-brand-400'
            : 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300'">
          {{ segment.type === 'DYNAMIC' ? 'Dinámica' : 'Estática' }}
        </span>
        <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
          [ngClass]="{
            'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300': segment.status === 'DRAFT',
            'bg-amber-50 text-amber-700 dark:bg-amber-500/10 dark:text-amber-400': segment.status === 'CALCULATING',
            'bg-emerald-50 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-400': segment.status === 'READY',
            'bg-red-50 text-red-700 dark:bg-red-500/10 dark:text-red-400': segment.status === 'ERROR',
            'bg-orange-50 text-orange-700 dark:bg-orange-500/10 dark:text-orange-400': segment.status === 'SUPPRESSED',
            'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300': segment.status === 'ARCHIVED'
          }">
          {{ segment.status === 'READY' ? 'Activo' :
             segment.status === 'DRAFT' ? 'Borrador' :
             segment.status === 'CALCULATING' ? 'Calculando...' :
             segment.status === 'ERROR' ? 'Error' :
             segment.status === 'SUPPRESSED' ? 'Suprimido' :
             segment.status === 'ARCHIVED' ? 'Archivado' : segment.status }}
        </span>
        @if (segment.isSystem) {
        <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-50 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-400">
          Sistema
        </span>
        }
        @if (segment.isSuppressionList) {
        <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-300">
          Supresión
        </span>
        }
      </div>
    </div>

    <!-- Action buttons -->
    <div class="flex-shrink-0 flex flex-col items-end gap-2">
      <button (click)="onEdit()"
        class="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium bg-brand-500 hover:bg-brand-600 text-white transition-colors">
        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
        </svg>
        Editar
      </button>
      @if (segment.type === 'DYNAMIC') {
      <button type="button" (click)="evaluarSegmento()" [disabled]="isEvaluating"
        class="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium border border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-400 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
        @if (isEvaluating) {
          <div class="animate-spin rounded-full h-3.5 w-3.5 border-b-2 border-current"></div>
          Calculando...
        } @else {
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
          </svg>
          Actualizar Lista
        }
      </button>
      }
    </div>
  </div>

  <!-- Tabs -->
  <div class="border-b border-gray-200 dark:border-gray-700 mb-6">
    <nav class="-mb-px flex gap-1">
      <button (click)="setTab('info')"
        class="whitespace-nowrap px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
        [class.border-brand-500]="activeTab === 'info'"
        [class.text-brand-600]="activeTab === 'info'"
        [class.dark:text-brand-400]="activeTab === 'info'"
        [class.border-transparent]="activeTab !== 'info'"
        [class.text-gray-500]="activeTab !== 'info'"
        [class.dark:text-gray-400]="activeTab !== 'info'">
        Información
      </button>
      <button (click)="setTab('timeline')"
        class="whitespace-nowrap px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
        [class.border-brand-500]="activeTab === 'timeline'"
        [class.text-brand-600]="activeTab === 'timeline'"
        [class.dark:text-brand-400]="activeTab === 'timeline'"
        [class.border-transparent]="activeTab !== 'timeline'"
        [class.text-gray-500]="activeTab !== 'timeline'"
        [class.dark:text-gray-400]="activeTab !== 'timeline'">
        Línea de Tiempo
      </button>
    </nav>
  </div>

  <!-- ========== TAB: INFORMACIÓN ========== -->
  @if (activeTab === 'info') {
  <div class="space-y-6">

    <!-- Sección: Detalles del Segmento -->
    <div>
      <h3 class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-4">
        Detalles del Segmento
      </h3>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">

        <!-- Tipo -->
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 mt-0.5">
            <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"/>
            </svg>
          </div>
          <div class="min-w-0 flex-1">
            <p class="text-xs text-gray-500 dark:text-gray-400">Tipo</p>
            <p class="text-sm font-medium text-gray-900 dark:text-white">{{ segment.type === 'DYNAMIC' ? 'Dinámica' : 'Estática' }}</p>
          </div>
        </div>

        <!-- Estado -->
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 mt-0.5">
            <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
          </div>
          <div class="min-w-0 flex-1">
            <p class="text-xs text-gray-500 dark:text-gray-400">Estado</p>
            <p class="text-sm font-medium text-gray-900 dark:text-white">
              {{ segment.status === 'READY' ? 'Activo' :
                 segment.status === 'DRAFT' ? 'Borrador' :
                 segment.status === 'CALCULATING' ? 'Calculando' :
                 segment.status === 'ERROR' ? 'Error' :
                 segment.status === 'SUPPRESSED' ? 'Suprimido' :
                 segment.status === 'ARCHIVED' ? 'Archivado' : segment.status }}
            </p>
          </div>
        </div>

        <!-- Tipo de Objeto -->
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 mt-0.5">
            <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"/>
            </svg>
          </div>
          <div class="min-w-0 flex-1">
            <p class="text-xs text-gray-500 dark:text-gray-400">Tipo de Objeto</p>
            <p class="text-sm font-medium text-gray-900 dark:text-white">
              {{ segment.objectType === 'CONTACT' ? 'Contactos' :
                 segment.objectType === 'COMPANY' ? 'Empresas' :
                 segment.objectType === 'DEAL' ? 'Negocios' : segment.objectType }}
            </p>
          </div>
        </div>

        <!-- Total de Miembros -->
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 mt-0.5">
            <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
            </svg>
          </div>
          <div class="min-w-0 flex-1">
            <p class="text-xs text-gray-500 dark:text-gray-400">Total de Miembros</p>
            <p class="text-sm font-medium text-gray-900 dark:text-white">{{ segment.totalContacts }}</p>
          </div>
        </div>

        <!-- Carpeta -->
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 mt-0.5">
            <svg class="w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
              <path d="M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"/>
            </svg>
          </div>
          <div class="min-w-0 flex-1">
            <p class="text-xs text-gray-500 dark:text-gray-400">Carpeta</p>
            <p class="text-sm font-medium text-gray-900 dark:text-white">{{ segment.folderName || '—' }}</p>
          </div>
        </div>

        <!-- Última Evaluación (DYNAMIC only) -->
        @if (segment.type === 'DYNAMIC') {
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 mt-0.5">
            <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
          </div>
          <div class="min-w-0 flex-1">
            <p class="text-xs text-gray-500 dark:text-gray-400">Última Evaluación</p>
            <p class="text-sm font-medium text-gray-900 dark:text-white">
              {{ segment.datetimeLastEvaluated | datetime }}
            </p>
          </div>
        </div>
        }

      </div>

      <!-- Descripción (solo si existe) -->
      @if (segment.description) {
      <div class="mt-5 flex items-start gap-3">
        <div class="flex-shrink-0 mt-0.5">
          <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h10"/>
          </svg>
        </div>
        <div class="min-w-0 flex-1">
          <p class="text-xs text-gray-500 dark:text-gray-400">Descripción</p>
          <p class="text-sm text-gray-700 dark:text-gray-300 mt-0.5 whitespace-pre-wrap break-words">{{ segment.description }}</p>
        </div>
      </div>
      }
    </div>

    <!-- Timestamps -->
    <div class="pt-4 border-t border-gray-200 dark:border-gray-700">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">

        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 mt-0.5">
            <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
            </svg>
          </div>
          <div class="min-w-0 flex-1">
            <p class="text-xs text-gray-500 dark:text-gray-400">Fecha de Creación</p>
            <p class="text-sm font-medium text-gray-900 dark:text-white">{{ segment.datetimeCreated | datetime }}</p>
          </div>
        </div>

        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 mt-0.5">
            <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
            </svg>
          </div>
          <div class="min-w-0 flex-1">
            <p class="text-xs text-gray-500 dark:text-gray-400">Última Actualización</p>
            <p class="text-sm font-medium text-gray-900 dark:text-white">{{ segment.datetimeUpdated | datetime }}</p>
          </div>
        </div>

      </div>
    </div>

    <!-- Evaluación Programada + Historial (DYNAMIC only) -->
    @if (segment.type === 'DYNAMIC') {
    <app-segment-schedule-section [segmentId]="segmentId" />
    }

    <!-- Operaciones de Conjuntos -->
    <app-segment-set-ops-section [segmentId]="segmentId" [showButton]="false" (executed)="onSetOpExecuted()" />

    <!-- Contactos en este Segmento -->
    <div class="pt-4 border-t border-gray-200 dark:border-gray-700">
      <h3 class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-4">Contactos en este Segmento</h3>
      <app-segment-members-table
        [segmentId]="segmentId"
        [segmentType]="segment.type"
        (segmentGone)="handleSegmentGone()" />
    </div>

  </div>
  } <!-- end info tab -->

  <!-- ========== TAB: LÍNEA DE TIEMPO ========== -->
  @if (activeTab === 'timeline') {
  <app-audit-timeline
    [logs]="auditLogs"
    [loading]="isLoadingAudit"
    [error]="auditError"
    [currentPage]="auditPage"
    [totalPages]="auditTotalPages"
    [totalElements]="auditTotalElements"
    emptyMessage="No hay eventos de auditoría para este segmento."
    (pageChange)="cargarAuditoria($event)" />
  } <!-- end timeline tab -->

</div>
}
</app-modal>

